import GetParamUrl from "../common/getParamUrl"
import sha1 from "sha1"

// Prepare GTM data with Redux Store.
const setDataLayer = (commonData = "", firstRequest = false) => {
	if (commonData === "" || commonData.page === null) return {}

	const { page, data: dataStore } = commonData
	const defaultkeyVal = null

	const datalayerObj = {
		event: "pageviewCustomEvent",
		page: page,
		platform: "www",
		params: getParamUrl(),
		fbPixel: getFbPixel(page, dataStore),
		nielsen: getNielsen(dataStore),
		tags: dataStore.tags || defaultkeyVal,
		topic: dataStore.topicName || defaultkeyVal,
		action: page === "content" ? "view" : "browse",
		fullPath: dataStore.fullPath || defaultkeyVal,
		section: dataStore.sectionName || defaultkeyVal,
		"gtm.newUrlFragment": dataStore.canonical || "",
		hrefUrl: window.location.href,
	}

	if (firstRequest) delete datalayerObj.event

	return datalayerObj
}

function getParamUrl() {
	let params = {
		AdsGoogle: false,
		AdsCxense: false,
		AdsTaboola: false,
		AdsFacebook: false,
	}

	if (process.browser) {
		params.AdsGoogle = GetParamUrl("AdsGoogle") === "true" && true
		params.AdsCxense = GetParamUrl("AdsCxense") === "true" && true
		params.AdsTaboola = GetParamUrl("AdsTaboola") === "true" && true
		params.AdsFacebook = GetParamUrl("AdsFacebook") === "true" && true
	}

	return params
}

function getNielsen(dataStore = undefined) {
	if (dataStore !== undefined) {
		const assetid = dataStore.canonical !== undefined ? dataStore.canonical.replace("https://www.thairath.co.th", "") : ""
		let nielsenObj = {
			type: "static",
			assetid: sha1(assetid).substr(0, 10),
			section: `Thairath-${dataStore.sectionName}`,
			segB: "thairath.co.th",
		}
		return nielsenObj
	}
}

function getFbPixel(pageName = "", dataStore = undefined) {
	let fbPixelTract = {}
	switch (pageName) {
		case "content":
			if (dataStore !== undefined) {
				fbPixelTract = {
					content_name: dataStore.title,
					content_category: dataStore.fullPath,
					content_type: "content",
				}
			}
			break
		case "home":
			fbPixelTract = {
				content_name: "ข่าวล่าสุด ข่าวด่วน ข่าวเด่นวันนี้ ข่าวไทยรัฐ",
				content_category: "homepage",
				content_type: "homepage",
			}
		default:
			fbPixelTract = {
				content_name: dataStore.title,
				content_category: dataStore.fullPath,
				content_type: "section",
			}
	}
	return fbPixelTract
}

export default setDataLayer
